// extracted by mini-css-extract-plugin
export default {"Eggy":"Eggy_Eggy__6CrLB","purple":"Eggy_purple__4yLo0","green":"Eggy_green__G6peE","white":"Eggy_white__owzuL","face":"Eggy_face__Vi0m-","EggyTrademark":"Eggy_EggyTrademark__+1xsW"};